import { FieldSet, Slider, NumberInput } from '@wix/design-system';
import React__default, { useContext, useRef, useState } from 'react';
import { ZIndexContext } from 'ricos-context';

const SliderWithInput = ({
  min,
  max,
  onChange,
  label,
  sliderDataHook,
  inputDataHook,
  value,
  tooltipTextKey
}) => {
  const zIndexService = useContext(ZIndexContext);
  const inputRef = useRef(null);
  const [inputKey, setInputKey] = useState(0);
  const handleInputWithinBounds = (data) => {
    const numberValue = Number(data);
    const valueWithinBounds = isNaN(numberValue) || numberValue < min ? min : numberValue > max ? max : numberValue;
    if (value !== valueWithinBounds) {
      onChange(valueWithinBounds);
      return;
    }
    setInputKey((prev) => prev + 1);
  };
  return /* @__PURE__ */ React__default.createElement(
    FieldSet,
    {
      legend: label,
      legendSize: "small",
      legendPlacement: "top",
      columns: "auto 60px",
      infoContent: tooltipTextKey,
      infoTooltipProps: {
        appendTo: (el) => {
          var _a;
          return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
        },
        // @ts-expect-error
        zIndex: zIndexService.getZIndex("TOOLTIP")
      }
    },
    /* @__PURE__ */ React__default.createElement(
      Slider,
      {
        onChange: (value2) => {
          const newValue = value2 || value2[0];
          onChange(newValue);
        },
        min,
        max,
        value,
        displayMarks: false,
        dataHook: sliderDataHook
      }
    ),
    /* @__PURE__ */ React__default.createElement(
      NumberInput,
      {
        key: inputKey,
        inputRef,
        value,
        min,
        max,
        onChange: (value2) => {
          if (value2 !== null) {
            onChange(value2);
          }
        },
        size: "small",
        hideStepper: true,
        dataHook: inputDataHook,
        onBlur: (e) => handleInputWithinBounds(e.target.value),
        onKeyDown: (e) => {
          var _a;
          if (e.key === "Enter") {
            handleInputWithinBounds((_a = inputRef.current) == null ? void 0 : _a.value);
          }
        }
      }
    )
  );
};

export { SliderWithInput };
//# sourceMappingURL=slider-with-input.js.map
